<template>
  <div class="card-section">
    <div class="card-header">
      <h2 class="card-title">
        <font-awesome-icon
          v-if="icon"
          :icon="['far', icon]"
          size="lg"
        /><span>{{ title }}</span>
      </h2>
      <div class="card-toolbar">
        <a
          v-if="link"
          :href="linkUrl"
        >{{ link }}</a>
        <router-link
          v-if="routerLink"
          class="nav-link"
          :to="{name: routerLinkName, query: campaignQuery}"
        >
          {{ routerLink }}
        </router-link>
        <a
          v-if="toggle"
          class="btn btn-icon card-toolbar-icon"
          @click="show = !show"
        >
          <span
            v-if="show"
            class="icon-chevron-down"
          />
          <span
            v-if="!show"
            class="icon-chevron-up"
          />
        </a>
      </div>
    </div>
    <transition name="slide">
      <div
        v-if="show"
        class="card-body"
      >
        <slot />
      </div>
    </transition>
  </div>
</template>

<script>
export default {
  name: 'Card',
  props: {
    icon: String,
    title: String,
    toggle: Boolean,
    link: String,
    linkUrl: String,
    routerLink: String,
    routerLinkName: String,
    tab: String
  },
  data () {
    return {
      show: true,
      campaignQuery: {
        clientId: this.$route.query.clientId,
        companyId: this.$route.query.companyId,
        campaignId: this.$route.query.campaignId,
        userEmail: this.$route.query.userEmail,
        tab: this.tab
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.slide-enter {
  opacity: 0;
  transform: translate3d(0, -10px, 0);
}
.slide-enter-active,
.slide-leave-active { transition: 0.3s ease-in }
.slide-leave-to {
  opacity: 0;
  transform: translate3d(0, -10px, 0);
}
.card-section {
    box-shadow: 0 0.125rem 0.5rem -0.0625rem rgba(0, 0, 0, 0.1);
    border: 1px solid #D1D1D1;
    margin-bottom: 2.8rem;
    border-radius: 3px;
    overflow: hidden;
    font-size: 1.6rem;
    .card-header:not(.card-header-tabs) {
        display: flex;
        justify-content: flex-start;
        align-items: center;
    }

    .card-header {
        padding: 0 2.3rem;
        background-color: #EBEBEB;
        border-bottom: none;
        height: 50px;
        .card-title {
            margin: 0;
            color: #000;
            font-size: 1.8rem;
            line-height: 40px;

            span, .svg-inline--fa {
                display: inline-block;
                vertical-align: middle;
            }
            .svg-inline--fa {
              margin-right: 7px;
            }
        }

        .card-toolbar {
            margin-left: auto;
            margin-right: -7px;
            display: flex;
            flex-flow: row nowrap;

            a {
                color: #444472;
                text-decoration: underline;
                font-size: 15px;
            }

            .card-toolbar-icon {
                text-decoration: none;
                transition: transform 0.5s;
            }

            .card-toolbar-icon--reverse {
                transform: rotateX(180deg);
            }
        }
    }

    .card-body {
        padding: 1.6rem 2.3rem 1.9rem;

        .empty-state {
            text-align: center;
            padding: 2rem;

            .empty-state__icon {
                font-size: 6.4rem;
                color: #ccc;
            }

            .empty-state__text {
                font-weight: bold;
            }
        }
    }

    .card-footer {
        padding: 0.5rem 1rem;
        border-top: 1px solid #EBEBEB;
        background-color: #fff;
        color: #666666;
        font-size: 0.875rem;

        &:empty {
            display: none;
        }
    }
}

</style>
